import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useMemo } from "react";
import { ThemeModeProvider, useThemeMode } from "./contexts/ThemeContext";
import CategoryView from "./pages/Imports/ImportCategory/CategoryView";
import Customers from "./pages/Customers/Customers";
import CustomerView from "./pages/Customers/CustomerView";
import EmailAuthentication from "./components/EmailAuthentication";
import Ex_Category from "./pages/Exports/ExportCategory/Ex_Categories";
import Ex_CategoryView from "./pages/Exports/ExportCategory/Ex_CategoyView";
import Ex_Items from "./pages/Exports/ExportItem/Ex_Items";
import Ex_ProductEdit from "./pages/Exports/ExportItem/Ex_ItemEdit";
import Ex_Production from "./pages/Exports/ExportItem/Ex_Production";
import Ex_ProductionView from "./pages/Exports/ExportItem/Ex_ProductionView";
import WarehouseProductView from "./pages/Exports/ExportItem/WarehouseProductView";
import ForgotPassword from "./pages/Authentication/ForgotPassword";
import Home from "./pages/Home";
import Im_Bill from "./pages/Imports/ImportBill/Im_Bill";
import Im_BillEdit from "./pages/Imports/ImportBill/Im_BillEdit";
import Im_Categories from "./pages/Imports/ImportCategory/Im_Categories";
import Im_ItemEdit from "./pages/Imports/ImportItem/Im_ItemEdit";
import Im_ReturnBill from "./pages/Imports/ImportBill/Im_returnBill";
import Im_ReturnBillView from "./pages/Imports/ImportBill/Im_returnBillView";
import Im_Stockupdates from "./pages/Imports/ImportStockIntake/Im_stockupdates";
import ImItems from "./pages/Imports/ImportItem/Im_Items";
import ImportBillView from "./pages/Imports/ImportBill/Im_BillView";
import ImportItemView from "./pages/Imports/ImportItem/Im_ItemView";
import Login from "./pages/Authentication/Login";
import Notifications from "./pages/Notification/Notifications";
import ResetPassword from "./pages/Authentication/ResetPassword";
import Retail_BillEdit from "./pages/WarehouseTransfers/WarehouseTransferBills/WarehouseTransferBillUpdatePayments";
import Retail_BillView from "./pages/WarehouseTransfers/WarehouseTransferBills/WarehouseTransferBillView";
import Retail_Sale_Bill from "./pages/WarehouseTransfers/WarehouseTransferBills/WarehouseTransferBills";
import Sale_BillEdit from "./pages/Sales/SaleBill/SaleBillUpdatePayments";
import Sale_BillItemView from "./pages/Sales/SaleBill/SaleBillItemView";
import Sale_Bills from "./pages/Sales/SaleBill/SaleBills";
import Sale_BillView from "./pages/Sales/SaleBill/SaleBillView";
import Sale_Product from "./pages/Sales/ProductSale/SaleProducts";
import Sale_ProductEdit from "./pages/Sales/ProductSale/SaleProductEdit";
import Sale_ProductView from "./pages/Sales/ProductSale/SaleProductView";
import Signup from "./pages/Authentication/Signup";
import StockUpdateView from "./pages/Imports/ImportStockIntake/StockUpdateView";
import Template from "./components/Template";
import UserEdit from "./pages/Users/UserEdit";
import Users from "./pages/Users/Users";
import Warehouses from "./pages/Exports/Warehouses/Warehouses";
import WarehouseUpdate from "./pages/Exports/Warehouses/WarehouseUpdate";
import SalesPerson from "./pages/WarehouseTransfers/SalesMan/Salesman";
import SalesmanUpdate from "./pages/WarehouseTransfers/SalesMan/SalesmanUpdate";
import UserUpdate from "./pages/Users/UserUpdate";
import SubOrderPerson from "./pages/Imports/SubOrderPerson/SubOrderPerson";
import SubOrderPersonEdit from "./pages/Imports/SubOrderPerson/SubOrderPersonEdit";
import SubOrderPersonView from "./pages/Imports/SubOrderPerson/SubOrderPersonView";
import SubOrder from "./pages/Imports/SubOrder/SubOrder";
import SubOrderView from "./pages/Imports/SubOrder/SubOrderView";
import SubOrderProduct from "./pages/Imports/SubOrderProduct/SubOrderProduct";
import SubOrderProductView from "./pages/Imports/SubOrderProduct/SubOrderProductView";
import SettingsPage from "./pages/Settings/SettingsPage";
import CustomerUpdate from "./pages/Customers/UpdateCustomer";
import Routes from "./pages/Routes/Routes";
import RouteView from "./pages/Routes/RouteView";
import ImportPrices from "./pages/Imports/ImportPrice/ImportPrices";
import ExProductPriceList from "./pages/Exports/ExportProductPrice/ExProductPriceList";
import ExProductPriceView from "./pages/Exports/ExportProductPrice/ExProductPriceView";
import ProductBarcodeView from "./pages/Exports/ExportItem/ProductBarcodeView";
import ProductMaterialsManagement from "./pages/Exports/ExportItem/ProductMaterialsManagement";
import Ex_ProductionList from "./pages/Exports/ExportItem/Ex_ProductionList";
import ReportTemplateList from "./pages/ReportBuilder/ReportTemplateList";
import ReportBuilderPage from "./pages/ReportBuilder/ReportBuilderPage";
import LabelTemplateList from "./pages/LabelDesigner/LabelTemplateList";
import LabelDesignerPage from "./pages/LabelDesigner/LabelDesignerPage";

function AppWithTheme() {
  const { isDark } = useThemeMode();

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: isDark ? "dark" : "light",
          primary: { main: "#5b89bf" },
          secondary: { main: "#C62828" },
          background: {
            default: isDark ? "#121212" : "#F5F7FA",
            paper: isDark ? "#1E1E1E" : "#FFFFFF",
          },
          text: {
            primary: isDark ? "#E0E0E0" : "#2A3747",
            secondary: isDark ? "#B0B0B0" : "#5A6978",
          },
          error: { main: "#C62828" },
          warning: { main: "#F9A825" },
          info: { main: "#3F6C9E" },
          success: { main: "#2E7D32" },
        },
        typography: {
          fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
          h1: { fontWeight: 500 },
          button: { textTransform: "none" },
        },
        shape: { borderRadius: 8 },
        shadows: [...createTheme().shadows],
      }),
    [isDark]
  );

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Switch>
          <Route exact path="/">
            <Login />
          </Route>
          <Route exact path="/register">
            <Signup />
          </Route>
          <Route exact path="/forgotpassword">
            <ForgotPassword />
          </Route>
          <Route exact path="/resetpassword/:email/:token">
            <ResetPassword />
          </Route>
          <Route exact path="/approve/:billCategory/:billId/:approved">
            <EmailAuthentication />
          </Route>
          <Route path="/template">
            <Template>
              <Switch>
                <Route path="/template/home">
                  <Home />
                </Route>
                <Route path="/template/im_items">
                  <ImItems />
                </Route>
                <Route path="/template/im_prices">
                  <ImportPrices />
                </Route>
                <Route path="/template/im_categories">
                  <Im_Categories />
                </Route>
                <Route path="/template/im_bills">
                  <Im_Bill />
                </Route>
                <Route path="/template/im_stockupdates">
                  <Im_Stockupdates />
                </Route>
                <Route path="/template/im_item_view/:importId">
                  <ImportItemView />
                </Route>
                <Route path="/template/im_category_view/:cat_id">
                  <CategoryView />
                </Route>
                <Route path="/template/stock_update_view/:intakeId">
                  <StockUpdateView />
                </Route>
                <Route path="/template/im_bill_view/:billId">
                  <ImportBillView />
                </Route>
                <Route path="/template/im_bill_edit/:billId">
                  <Im_BillEdit />
                </Route>
                <Route path="/template/im_bill_return/:billId">
                  <Im_ReturnBill />
                </Route>
                <Route path="/template/im_bill_return_view/:billId">
                  <Im_ReturnBillView />
                </Route>
                <Route path="/template/im_item_edit/:importId">
                  <Im_ItemEdit />
                </Route>
                <Route path="/template/sub_order_person">
                  <SubOrderPerson />
                </Route>
                <Route path="/template/sub_order_product">
                  <SubOrderProduct />
                </Route>
                <Route path="/template/sub_order_product_view/:subProductId">
                  <SubOrderProductView />
                </Route>
                <Route path="/template/sub_order_person_view/:personId">
                  <SubOrderPersonView />
                </Route>
                <Route path="/template/sub_order_person_edit/:personId">
                  <SubOrderPersonEdit />
                </Route>
                <Route path="/template/sub_order">
                  <SubOrder />
                </Route>
                <Route path="/template/sub_order_view/:orderId">
                  <SubOrderView />
                </Route>
                <Route path="/template/ex_categories">
                  <Ex_Category />
                </Route>
                <Route path="/template/ex_category_view/:cat_id">
                  <Ex_CategoryView />
                </Route>
                <Route path="/template/ex_items">
                  <Ex_Items />
                </Route>
                <Route path="/template/ex_product_prices">
                  <ExProductPriceList />
                </Route>
                <Route path="/template/ex_product_price_view/:barcode">
                  <ExProductPriceView />
                </Route>
                <Route path="/template/ex_product_edit/:productId">
                  <Ex_ProductEdit />
                </Route>
                <Route exact path="/template/warehouse-product/:productId">
                  <WarehouseProductView />
                </Route>
                <Route exact path="/template/product/:barcodeId">
                  <ProductBarcodeView />
                </Route>
                <Route exact path="/template/product/materials/:barcodeId">
                  <ProductMaterialsManagement />
                </Route>
                <Route exact path="/template/sale_products">
                  <Sale_Product />
                </Route>
                <Route path="/template/sale_product_view/:saleId">
                  <Sale_ProductView />
                </Route>
                <Route path="/template/sale_product_edit/:saleId">
                  <Sale_ProductEdit />
                </Route>
                <Route path="/template/production/:productId">
                  <Ex_Production />
                </Route>
                <Route path="/template/ex_production">
                  <Ex_ProductionList />
                </Route>
                <Route path="/template/ex_production_view/:productionId">
                  <Ex_ProductionView />
                </Route>
                <Route exact path="/template/label-designer">
                  <LabelTemplateList />
                </Route>
                <Route path="/template/label-designer/new">
                  <LabelDesignerPage />
                </Route>
                <Route path="/template/label-designer/edit/:labelId">
                  <LabelDesignerPage />
                </Route>
                <Route path="/template/sale_bills">
                  <Sale_Bills />
                </Route>
                <Route path="/template/sale_bill_view/:billId">
                  <Sale_BillView />
                </Route>
                <Route path="/template/sale_bill_edit/:billId">
                  <Sale_BillEdit />
                </Route>
                <Route path="/template/sale_bill_item_view/:productId/:billNumber">
                  <Sale_BillItemView />
                </Route>
                <Route path="/template/customers">
                  <Customers />
                </Route>
                <Route path="/template/update_customer/:customerId">
                  <CustomerUpdate />
                </Route>
                <Route path="/template/routes">
                  <Routes />
                </Route>
                <Route path="/template/route_view/:routeId">
                  <RouteView />
                </Route>
                <Route path="/template/retail_sale_bills">
                  <Retail_Sale_Bill />
                </Route>
                <Route path="/template/retail_bill_view/:billId">
                  <Retail_BillView />
                </Route>
                <Route path="/template/retail_bill_edit/:billId">
                  <Retail_BillEdit />
                </Route>
                <Route path="/template/salesman">
                  <SalesPerson />
                </Route>
                <Route path="/template/salesman_update/:salesmanId">
                  <SalesmanUpdate />
                </Route>
                <Route path="/template/customer_view/:customerId">
                  <CustomerView />
                </Route>
                <Route path="/template/notifications">
                  <Notifications />
                </Route>
                <Route path="/template/warehouses">
                  <Warehouses />
                </Route>
                <Route path="/template/users">
                  <Users />
                </Route>
                <Route path="/template/settings">
                  <SettingsPage />
                </Route>
                <Route exact path="/template/report-builder">
                  <ReportTemplateList />
                </Route>
                <Route path="/template/report-builder/new">
                  <ReportBuilderPage />
                </Route>
                <Route path="/template/report-builder/edit/:templateId">
                  <ReportBuilderPage />
                </Route>
                <Route path="/template/user_edit/:userId">
                  <UserEdit />
                </Route>
                <Route path="/template/user_update/:userId">
                  <UserUpdate />
                </Route>
                <Route path="/template/warehouse_update/:warehouseId">
                  <WarehouseUpdate />
                </Route>
              </Switch>
            </Template>
          </Route>
        </Switch>
      </Router>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeModeProvider>
      <AppWithTheme />
    </ThemeModeProvider>
  );
}

export default App;
